import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "../layouts/dashboard";
import MainLayout from "../layouts/main";
import { DEFAULT_PATH } from "../config";
import LoadingScreen from "../components/LoadingScreen";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    localStorage.getItem("loggedIn")
      ? {
        path: "/",
        element: <DashboardLayout />,
        children: [
          { element: <Navigate to={DEFAULT_PATH} replace />, index: true },
          { path: "app", element: <GeneralApp /> },
          { path: "template", element: <TemplateComp /> },
          { path: "services", element: <Services /> },
          { path: "stylists", element: <Therapists /> },
          { path: "appointments", element: <Appointments /> },
          ...(process.env.REACT_APP_DEVELOPMENT === '1' ? [{ path: "test-flow", element: <TestFlow /> }] : []),
          { path: "404", element: <Page404 /> },
          { path: "*", element: <Navigate to="/404" replace /> },
        ],
      }
      : {
        path: "/",
        element: <MainLayout />,
        children: [
          { path: "", element: <LoginPage /> },
          { path: "*", element: <Navigate to="/" replace /> },
        ],
      },
  ]);
}

const GeneralApp = Loadable(
  lazy(() => import("../pages/dashboard/GeneralApp"))
);

const LoginPage = Loadable(lazy(() => import("../pages/auth/Login")));

const TemplateComp = Loadable(
  lazy(() => import("../pages/dashboard/template/index"))
);

const Services = Loadable(
  lazy(() => import("../pages/dashboard/Services"))
);

const Therapists = Loadable(
  lazy(() => import("../pages/dashboard/Therapists"))
);

const Appointments = Loadable(
  lazy(() => import("../pages/dashboard/Appointments"))
);

const TestFlow = Loadable(
  lazy(() => import("../pages/dashboard/TestFlow"))
);

const Page404 = Loadable(lazy(() => import("../pages/Page404")));
